import { FinancialSettingsType } from "@/store/modules/financial";

export type CurrencyConversionService = {
    convertCurrency(value: number, fromCurrencyId: number, toCurrencyId: number): number;
}

export function currencyConversionServiceFactory(settings: FinancialSettingsType){
    return {
        convertCurrency(value: number, fromCurrencyId: number, toCurrencyId: number){
            if (fromCurrencyId == toCurrencyId){
                return value;
            }
            else if (fromCurrencyId == settings.workingCurrency.id && toCurrencyId == settings.formalCurrency.id) {
                return value * settings.workingToFormalConversionRate;
            }
            else if (fromCurrencyId == settings.formalCurrency.id && toCurrencyId == settings.workingCurrency.id) {
                return value * settings.formalToWorkingConversionRate;
            }
            //historic currency conversion
            else if (settings.historicCurrency?.id && settings.historicConversionRate && settings.formalCurrency.id == settings.workingCurrency.id && fromCurrencyId == settings.historicCurrency?.id) {
                return value * (1 / settings.historicConversionRate);
            }
            else if (settings.historicCurrency?.id && settings.historicConversionRate && settings.formalCurrency.id == settings.workingCurrency.id && toCurrencyId == settings.historicCurrency?.id) {
                return value * settings.historicConversionRate;
            }

            throw new Error("Currency conversion failed! Attempted to convert to or from a currency not set as tenant's working or formal currency!");
        }
    }
}